/* eslint-disable no-useless-escape */

export const isEmpty = (value) => {
    return (value === null || value === undefined || value.length === 0);
};

export const isValidEmail = (value) => {
    //let reg = /^\w+([\.-]?\w+)@\w+([\.-]?\w+)(\.\w{2,3})+$/;
    let reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !reg.test(value);
};

export const isName = (value) => {
    let reg = /^[A-Za-z\s]{1,}[\.]{0,1}[A-Za-z\s]{0,}$/;
    return !reg.test(value);
};

export const isNumber = (value) => {
    let reg = /^[0-9]+$/;
    return !reg.test(value);
}

export const isFloatNumber = (value) => {
    let reg = /^[+-]?\d+(\.\d+)?$/;
    return !reg.test(value);
}

export const isNameWithNumber = (value) => {
    let reg = /^[a-zA-Z0-9_.-]*$/;
    return !reg.test(value);
}

export const isNameWithNumberSapce = (value) => {
    let reg = /^[a-zA-Z0-9 _.-]*$/;
    return !reg.test(value);
}

export const isNameWithSapce = (value) => {
    let reg = /^[a-z][a-z\s]*$/;
    return !reg.test(value);
}

export const passwordValidation = (value) => {
    let reg = /^[^ /]+$/;
    return !reg.test(value);
}

export const emptyValidation = (field, value, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        //errors = field + " field cannot be blank";
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    }
    return { isValid, errors };
}

export const customNumberValidation = (field, value, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (isFloatNumber(value)) {
        isValid = false;
        errors = "Enter a valid value in " + field;
    }
    return { isValid, errors };
}

export const customNumberValidationQuantity = (field, value, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value) || parseFloat(value) === 0) {
        isValid = false;
        errors = "Please enter a valid value in " + field;
    } else if (isFloatNumber(value)) {
        isValid = false;
        errors = "Enter a valid value in " + field;
    }
    return { isValid, errors };
}

export const customEmailValidation = (field, value, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (isValidEmail(value)) {
        isValid = false;
        errors = "Please Enter Your Valid Email";
    }
    return { isValid, errors };
}

export const customEmailOptionalValidation = (field, value) => {
    let isValid = true;
    let errors = '';
    if (value === null || value === undefined || value.length === 0) {
        isValid = true;
    } else if (isValidEmail(value)) {
        isValid = false;
        errors = "Enter a valid value in " + field;
    }
    return { isValid, errors };
}

export const customAlaphaNumericValidation = (field, value, length = 10, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (isNameWithNumberSapce(value)) {
        isValid = false;
        errors = field + " allow only alphabets & numbers";
    } else if (value.length !== length) {
        isValid = false;
        errors = "You must enter " + length + " character only";
    }
    return { isValid, errors };
}

export const customAlaphabetValidation = (field, value, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (isName(value)) {
        isValid = false;
        errors = "Please enter a valid value in " + field;
    }
    return { isValid, errors };
}

export const customAlaphabetValidationOptional = (field, value) => {
    let isValid = true;
    let errors = '';
    if (value === null || value === undefined || value.length === 0) {
        isValid = true;
    } else if (isName(value)) {
        isValid = false;
        errors = "Please enter a valid value in " + field;
    }
    return { isValid, errors };
}



export const customAlaphaNumericValidationOptional = (field, value, length = 10) => {
    let isValid = true;
    let errors = '';
    if (value === null || value === undefined || value.length === 0) {
        isValid = true;
    } else if (isNameWithNumberSapce(value)) {
        isValid = false;
        errors = field + " allow only alphabets & numbers";
    } else if (value.length !== length) {
        isValid = false;
        errors = "You must enter " + length + " character only";
    }
    return { isValid, errors };
}


export const customAlaphaNumeric = (field, value, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (isNameWithNumberSapce(value)) {
        isValid = false;
        errors = field + " allow only alphabets & numbers";
    }
    return { isValid, errors };
}


export const customAlaphaNumericOptional = (field, value) => {
    let isValid = true;
    let errors = '';
    if (value === null || value === undefined || value.length === 0) {
        isValid = true;
    } else if (isNameWithNumberSapce(value)) {
        isValid = false;
        errors = field + " allow only alphabets & numbers";
    }
    return { isValid, errors };
}

export const customPhoneValidation = (field, value, length = 10, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (isNumber(value)) {
        isValid = false;
        errors = "Please enter a valid value in " + field;
    } else if (value.length !== length) {
        isValid = false;
        errors = "You must enter " + length + " numbers only";
    }
    return { isValid, errors };
}

export const customPhoneValidationOptional = (field, value, length = 10) => {
    let isValid = true;
    let errors = '';
    if (value === null || value === undefined || value.length === 0) {
        isValid = true;
    } else if (isNumber(value)) {
        isValid = false;
        errors = "Please enter a valid value in " + field;
    } else if (value.length !== length) {
        isValid = false;
        errors = "You must enter " + length + " numbers";
    }
    return { isValid, errors };
}

export const customNumberValidationOptional = (field, value) => {
    let isValid = true;
    let errors = '';
    if (value !== null && (value === undefined || value.length === 0)) {
        isValid = true;
    } else if (isNumber(value)) {
        isValid = false;
        errors = "Please enter a valid value in " + field;
    }
    return { isValid, errors };
}



export const customDecimalValidation = (field, value, length = 6) => {
    let isValid = true;
    let errors = '';
    if (value === null || value === undefined || value.length === 0) {
        isValid = true;
    } else if (value > 6) {
        isValid = false;
        errors = "Allow 6 decimals only";
    }
    return { isValid, errors };
}

export const customPassword = (field, password, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(password)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (password.length < 6 || password.length > 20) {
        isValid = false;
        errors = "Enter minimum of 6 chars to max of 20 chars only";
    }
    // else if (passwordValidation(password)) {
    //     isValid = false;
    //     errors = "Re-enter password to match rules";
    // }
    return { isValid, errors };
}

export const customAlaphaNumericOnlyValidation = (field, value, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (isNameWithNumberSapce(value)) {
        isValid = false;
        errors = "Please enter a valid value in " + field;
    }
    return { isValid, errors };
}

export const customAadharValidation = (field, value, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (isNumber(value)) {
        isValid = false;
        errors = "Please enter Your Valid " + field;
    }
    return { isValid, errors };
}

export const customPasswordMatch = (field, newPassword, confirmPassword, type = 'input') => {
    let isValid = true;
    let errors = '';

    if (isEmpty(confirmPassword)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value  in " + field;
    } else if (newPassword !== confirmPassword) {
        isValid = false;
        errors = "New Password donesn't match";
    }
    return { isValid, errors };
}


export const quantityCheck = (field, value, type = 'input') => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value in " + field;
    } else if (value < 1) {
        isValid = false;
        errors = field + " field cannot be less than one";
    }
    return { isValid, errors };
}

export const stringLengthValidation = (field, value, type = 'input', length = 10) => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = false;
        errors = type === 'input' ? "Please enter a valid value in " + field : "Please select/enter a valid value in " + field;
    } else if (value.length !== length) {
        isValid = false;
        errors = "You must enter below " + length + " characters";
    }
    return { isValid, errors };
}

export const stringLengthOptionalValidation = (field, value, length = 10) => {
    let isValid = true;
    let errors = '';
    if (isEmpty(value)) {
        isValid = true;
    } else if (value.length > length) {
        isValid = false;
        errors = "You must enter below " + length + " characters";
    }
    return { isValid, errors };
}